export enum IrisModules {
  ADMINISTRATION = 'ADMIN',
  ALARMING = 'ALARMING',
  AUTO_REPORTS = 'AUTO_REPORTS',
  BIM = 'BIM',
  BIM_ACTIONS = 'BIM_ACTIONS',
  BIM_COCKPIT = 'BIM_COCKPIT',
  CHARTS = 'CHARTTOOLAJS',
  CLIENTS = 'CLIENTS',
  CPD = 'CPD',
  DASHBOARDS = 'DASHBOARDS_BETA',
  DISCUSSIONS = 'DISCUSSIONS',
  DEVICE_DATA = 'DEVICE_DATA',
  EMAIL = 'EMAIL',
  SIA = 'SIA',
  DMS = 'DMS',
  DMS2 = 'dms2',
  DYNAMIC_FORMS = 'DYNAMIC_FORMS',
  DZY = 'DZY',
  HOME = 'HOME',
  IMS = 'IMS',
  PERSONNEL_MANAGEMENT = 'PERSONNEL_MGMT',
  PROJECTS = 'PROJECT_HIERARCHY',
  RESOURCE_PLANNING = 'RESOURCE_PLANNING',
  SENSORBOARDS = 'SENSORBOARDS',
  SENSORBOARD = 'BOARD',
  SYSTEMCONFIG = 'SYSTEMCONFIG',
  SENSORS = 'SENSORS',
  SENSOR_GROUPS = 'SENSOR_GROUPS',
  MEASUREMENT_EXPORT = 'MEASUREMENT_EXPORT',
  SENSORS_MS = 'SENSORS_MS',
  ROUND_LIST = 'ROUND_LIST',
  SECURITY = 'SECURITY',
}

export enum IrisModulesSubjects {
  Module = 'Module',
  Project = 'Project',
  Company = 'Company',
  DocumentTemplate = 'DocumentTemplate',
  Device = 'Device',
  ChartToolCollection = 'ChartToolCollection',
  Personnel = 'Personnel',
  IdentUser = 'IdentUser',
  ResoursePlanning = 'RESOURCE_PLANNING',
}

export enum IrisModulesActions {
  access = 'access',
  config = 'config',
  read = 'read',
  update = 'update',
  approve = 'approve',
  manageTrades = 'manageTrades',
  approveDevice = 'approveDevice',
  approveUser = 'approveUser',
  chartConfig = 'chartConfig',
}
